import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import constants from '../../../utility/constants';
import { ModuleService } from '../../module.service';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ManageAdminGuard  {
  constructor(
    private ms: ModuleService,
    private router: Router,
    private toast: ToastrService
  ) {}

  canLoad():
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    return this.shouldLoadOrAcitvate();
  }

  canActivate():
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    return this.shouldLoadOrAcitvate();
  }

  private shouldLoadOrAcitvate() {
    if (this.ms.userHas(constants.admin.modules.adminUserManagement))
      return true;
    this.toast.info("No sufficient permission to access 'Admin(s) Management'");
    this.router.navigate(['/admin/not-found']);
    return false;
  }
}
